//Query sting params for /unsubscribe & /unsubscribe_04867
export const genericUnsubscribeSearchParamKeys = ['c', 'e', 'j'];

//Query sting params for /optout
export const optoutSearchParamKeys = ['c', 'e', 'p', 'i'];

export const URL_PATH = "urlPath";